module.exports = __webpack_public_path__ + "img/resalat.6e8ca38a.svg";